import React from "react";

interface PageLayoutProps {
    title: string;
    rightContent?: React.ReactNode;
    children: React.ReactNode;
}

const PageLayout: React.FC<PageLayoutProps> = ({ title, rightContent, children }) => {
    return (
        <div className="min-h-screen bg-[#0a0a0a]">
            <div className="w-full max-w-[1600px] mx-auto px-4 sm:px-6 py-5 space-y-5">
                {/* Header */}
                <div className="flex items-center justify-between border-b border-[#1f1f1f] pb-4">
                    {/* Logo */}
                    <div className="flex-shrink-0">
                        <img src="/ss small.png" alt="SecuredStitch" className="h-8 w-auto md:hidden" />
                        <img src="/Black BG - Logo.png" alt="SecuredStitch" className="hidden md:block h-7 w-auto" />
                    </div>

                    {/* Title */}
                    <h1 className="absolute left-1/2 -translate-x-1/2 text-base sm:text-lg font-semibold text-white tracking-tight pointer-events-none">
                        {title}
                    </h1>

                    {/* Right slot */}
                    <div className="flex-shrink-0">{rightContent}</div>
                </div>

                {/* Content */}
                <div className="space-y-5">{children}</div>
            </div>
        </div>
    );
};

export default PageLayout;
